<div class="dialog feedback-dialog">
  @if (loading()) {
    <div class="dialog__loading-overlay">
      <mat-progress-spinner mode="indeterminate" diameter="40" />
    </div>
  }
  <div class="dialog__header">
    <h2 class="dialog__title">{{ 'feedback.title' | translate }}</h2>
    <button class="dialog__header-close" type="button" (click)="onCancel()" aria-label="Close">
      <app-icon class="dialog__header-close-icon" [icon]="IconName.CLOSE" />
    </button>
  </div>
  <form class="feedback-form" [formGroup]="form" (ngSubmit)="onSubmit()">
    <div class="field full-width">
      <div class="feedback-label feedback-label--required">
        {{ 'feedback.rateExperience' | translate }}
      </div>
      <div class="rating" (mouseleave)="clearHoveredRating()">
        @for (star of stars; track star; let i = $index) {
          <button
            type="button"
            class="rating__star-btn"
            (mouseenter)="setHoveredRating(star)"
            (click)="selectRating(star)"
            [attr.aria-label]="'feedback.rateAriaLabel' | translate: { count: star }"
          >
            <svg
              class="rating__star"
              [class.rating__star--filled]="filledStars()[i]"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M12 2.75L14.92 8.67L21.45 9.62L16.72 14.22L17.84 20.72L12 17.65L6.16 20.72L7.28 14.22L2.55 9.62L9.08 8.67L12 2.75Z"
              />
            </svg>
          </button>
        }
      </div>
      @if (ratingError()) {
        <div class="field-error">
          {{ 'feedback.ratingRequired' | translate }}
        </div>
      }
    </div>

    <div class="field full-width">
      <div class="feedback-label">
        {{ 'feedback.sectionTitle' | translate }}
      </div>
    </div>
    <div class="field full-width">
      <label class="feedback-input-label" for="feedback-title">
        {{ 'feedback.feedbackTitle' | translate }}
      </label>
      <input
        id="feedback-title"
        class="feedback-input"
        type="text"
        formControlName="title"
        [placeholder]="'feedback.titlePlaceholder' | translate"
      />
      @let titleError = titleError$ | async;
      @if (titleError) {
        <div class="field-error">
          {{ titleError }}
        </div>
      }
    </div>
    <div class="field full-width">
      <label class="feedback-input-label" for="feedback-text">
        {{ 'feedback.feedbackText' | translate }}
      </label>
      <textarea
        id="feedback-text"
        class="feedback-textarea"
        formControlName="text"
        [placeholder]="'feedback.textPlaceholder' | translate"
        rows="6"
      ></textarea>
      @let textError = textError$ | async;
      @if (textError) {
        <div class="field-error">
          {{ textError }}
        </div>
      }
    </div>
    <div class="public-checkbox">
      <label class="public-checkbox__label">
        <input class="public-checkbox__input" type="checkbox" formControlName="isPublic" />
        <span>{{ 'feedback.makePublic' | translate }}</span>
      </label>
      <div class="public-checkbox__hint">
        {{ 'feedback.makePublicHint' | translate }}
      </div>
    </div>

    <div class="form-actions">
      <div class="right-buttons">
        <button
          type="button"
          class="form-actions__button btn-cancel"
          (click)="onCancel()"
          [disabled]="loading()"
        >
          {{ 'feedback.cancel' | translate }}
        </button>
        <button type="submit" class="form-actions__button btn-save" [disabled]="loading()">
          {{ 'feedback.submit' | translate }}
        </button>
      </div>
    </div>
  </form>
</div>
